import { useRef, useState } from 'react';
import { Icon } from '@iconify/react';
import { useDispatch } from 'react-redux';
import { useNavigate, Link as RouterLink } from 'react-router-dom';
import personFill from '@iconify/icons-eva/person-fill';
import { alpha } from '@mui/material/styles';
import { Button, Box, Divider, MenuItem, Typography, Avatar, IconButton } from '@mui/material';
import MenuPopover from '../../components/MenuPopover';
import { resetStore } from '../../store/Actions';
import useLoginSelector from '../../store/Slice/Login/LoginSelector';

const moduleColor = '#13519d';
const ERROR = '#ef4444';

// ----------------------------------------------------------------------

const MENU_OPTIONS = [
  // {
  //   label: 'Home',
  //   icon: homeFill,
  //   linkTo: '/'
  // },
  {
    label: 'Profile',
    icon: personFill,
    linkTo: '#'
  }
  // {
  //   label: 'Settings',
  //   icon: settings2Fill,
  //   linkTo: '#'
  // }
];

export default function AccountPopover() {
  const anchorRef = useRef(null);
  const [open, setOpen] = useState(false);

  const navigate = useNavigate();
  const dispatch = useDispatch();

  const { LoginData } = useLoginSelector();

  const handleOpen = () => {
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
  };

  const handleLogOut = () => {
    dispatch(resetStore());
    localStorage.clear();
    sessionStorage.clear();
    navigate('/', { replace: true });
  };

  const userFullName = LoginData?.userFullName || 'User';
  const avatarLetter = userFullName.charAt(0).toUpperCase();

  return (
    <>
      <Box
        ref={anchorRef}
        onClick={handleOpen}
        sx={{
          display: 'flex',
          alignItems: 'center',
          gap: 1.5,
          cursor: 'pointer',
          pr: 0.5,
          pl: 1.5,
          py: 0.5,
          borderRadius: '999px',
          border: `1px solid ${moduleColor}`,
          bgcolor: `${moduleColor}04`,
          transition: 'all 0.2s',
          '&:hover': { bgcolor: `${moduleColor}08` },
          ...(open && {
            bgcolor: `${moduleColor}08`
          })
        }}
      >
        <Box
          component="img"
          src="../../static/logos/realValueLogo.jpg"
          alt="Real Value Logo"
          sx={{
            height: 31,
            width: 120,
            objectFit: 'contain',
            display: { xs: 'none', sm: 'block' }
          }}
        />
        <Avatar
          sx={{
            width: 34,
            height: 34,
            fontSize: '0.85rem',
            fontWeight: 800,
            bgcolor: moduleColor,
            color: '#fff',
            boxShadow: '0 2px 6px rgba(0,0,0,0.12)'
          }}
        >
          {avatarLetter}
        </Avatar>
      </Box>

      <MenuPopover
        open={open}
        onClose={handleClose}
        anchorEl={anchorRef.current}
        sx={{
          width: 250,
          p: 1,
          mt: 1.5,
          borderRadius: '14px',
          boxShadow: '0 12px 36px rgba(0,0,0,0.12)',
          border: '1px solid #e2e8f0'
        }}
      >
        <Box sx={{ px: 2, pt: 1.5, pb: 1, display: 'flex', alignItems: 'center', gap: 1.5 }}>
          <Avatar
            sx={{
              width: 44,
              height: 44,
              bgcolor: moduleColor,
              fontSize: '1rem',
              fontWeight: 800,
              boxShadow: '0 2px 8px rgba(0,0,0,0.15)'
            }}
          >
            {avatarLetter}
          </Avatar>
          <Box sx={{ minWidth: 0, flex: 1 }}>
            <Typography
              sx={{
                fontWeight: 800,
                fontSize: '0.92rem',
                color: '#1e293b',
                lineHeight: 1.2
              }}
            >
              {userFullName}
            </Typography>
          </Box>
        </Box>

        <Divider sx={{ my: 1, borderColor: '#f1f5f9' }} />

        {MENU_OPTIONS.map((option) => (
          <MenuItem
            key={option.label}
            to={option.linkTo}
            component={RouterLink}
            onClick={handleClose}
            sx={{
              px: 2,
              py: 1,
              borderRadius: '8px',
              '&:hover': { bgcolor: `${moduleColor}08` }
            }}
          >
            <Box
              component={Icon}
              icon={option.icon}
              sx={{
                mr: 1.5,
                width: 20,
                height: 20,
                color: moduleColor
              }}
            />
            <Typography sx={{ fontSize: '0.84rem', fontWeight: 700, color: '#1e293b' }}>
              {option.label}
            </Typography>
          </MenuItem>
        ))}

        <Divider sx={{ my: 1, borderColor: '#f1f5f9' }} />

        <MenuItem
          onClick={handleLogOut}
          sx={{
            px: 2,
            py: 1,
            borderRadius: '8px',
            '&:hover': { bgcolor: `${ERROR}08` }
          }}
        >
          <Typography sx={{ fontSize: '0.84rem', fontWeight: 700, color: ERROR }}>
            Logout
          </Typography>
        </MenuItem>
      </MenuPopover>
    </>
  );
}
